import { useEffect, useState } from "react";
import { Sparkles, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const TownSuggestions = ({ onAdd, country = "Italy" }) => {
  const [s, setS] = useState({ items: [] });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setS({ items: [] });
    api.get(`/suggestions?country=${encodeURIComponent(country)}`).then((r) => setS(r.data)).catch(() => {});
  }, [country]);

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/suggestions?country=${encodeURIComponent(country)}`);
      setS(data);
      toast.success(`Fresh ${country} suggestions ready`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const line = (i) => `${i.town}, ${i.region}`;

  return (
    <div className="bg-[#3B1B48] text-[#FAF7F2] p-7 mb-10" data-testid="town-suggestions">
      <div className="flex items-center gap-3 mb-2">
        <Sparkles className="w-5 h-5 text-[#C59B27]" strokeWidth={1.4} />
        <p className="eyebrow" data-testid="suggestions-country">Suggested next towns · {country}</p>
        {s.items.length > 0 && (
          <button data-testid="suggestions-add-all-button" onClick={() => onAdd(s.items.map(line))} className="ml-auto text-xs text-[#C59B27] hover:text-white">Add all to batch</button>
        )}
      </div>
      <p className="text-xs text-[#EFE6F3]/70 mb-5">{s.generated_at ? `Ranked by buyer interest using ${s.basis} · ${new Date(s.generated_at).toLocaleDateString("en-AU")}` : "Ranked by buyer interest: your sales, plus Australian expat demand, liveability and affordability."}</p>
      <div className="space-y-2 mb-5">
        {s.items.map((i, n) => (
          <div key={i.town} data-testid={`suggestion-${n}`} className="flex items-start gap-3 bg-[#FAF7F2]/5 p-3">
            <span className="font-display text-xl text-[#C59B27] w-8">{i.interest_score}</span>
            <div className="flex-1 text-sm">
              <p className="font-display text-base">{i.town} <span className="text-[#EFE6F3]/60 font-sans text-xs">{i.region}</span></p>
              <p className="text-xs text-[#EFE6F3]/80">{i.why}{i.similar_to ? ` · like ${i.similar_to}` : ""}</p>
            </div>
            <button data-testid={`suggestion-add-${n}`} onClick={() => onAdd([line(i)])} className="text-[#C59B27] hover:text-white mt-1" title="Add to batch"><Plus className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <Button data-testid="suggestions-generate-button" onClick={generate} disabled={busy} variant="outline" className="rounded-none border-[#C59B27] text-[#C59B27] bg-transparent hover:bg-[#C59B27] hover:text-[#1C181D]">
        {busy ? "Analysing demand…" : s.items.length ? "Refresh suggestions" : "Suggest towns"}
      </Button>
    </div>
  );
};
